import { Box, Button, Chip, Stack } from "@mui/material";
import { DataGrid, GridColDef, GridCellParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { RootState, useAppSelector } from "../../../store";
import PaginationControl from "../pagination/Pagination";
import Swal from "sweetalert2";
import { useDeleteUserAccMutation } from "../../../store/feature/service/UserAccountApiSlice";
import { useEffect } from "react";
import { useDeleteCmpnyMutation } from "../../../store/feature/service/companyApiSlice";

const CompanyTable = ({ data, params, setParams }: any) => {
  const navigate = useNavigate();
  const { company } = useAppSelector((state: RootState) => state.role);
  const [deleteCompany, { isSuccess, isError }] = useDeleteCmpnyMutation();

  const handleEdit = (userId: string, rowData: any) => {
    navigate(`/company/edit/${userId}`, { state: rowData });
  };

  const handleDelete = (userId: string) => {
    Swal.fire({
      title: "Delete Confirmation",
      text: "Are you sure you want to delete this user? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808080",
      confirmButtonText: "Yes, delete it",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCompany(userId);
      }
    });
  };

  const columns: GridColDef[] = [
    { field: "cmpnyName", headerName: "Company Name", flex: 1, minWidth: 250 },
    { field: "industry", headerName: "Industry", flex: 1, minWidth: 250 },
    { field: "cmpnyEmail", headerName: "Company Email", flex: 1, minWidth: 250 },
    { field: "inputted", headerName: "Iputted At", flex: 1, minWidth: 250 },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 1,
    //   minWidth: 200,
    //   headerAlign: "center",
    //   align: "center",
    //   renderCell: (params: GridCellParams) => {
    //     const status = params.row.status?.toLowerCase();
    //     if (status === "active") {
    //       return <Chip label="Active" color="success" variant="outlined" />;
    //     } else if (status === "inactive") {
    //       return <Chip label="Inactive" color="warning" variant="outlined" />;
    //     } else if (status === "deleted") {
    //       return <Chip label="Deleted" color="error" variant="outlined" />;
    //     }
    //     return null;
    //   },
    // },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 320,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params: GridCellParams) => (
        <Stack spacing={2} direction="row">
          {company.update && (
            <>
              <Button variant="contained" onClick={() => handleEdit(params.row.cmpnyUid, params.row)}>
                Update
              </Button>
            </>
          )}
          {company.delete && (
            <Button variant="contained" color="error" onClick={() => handleDelete(params.row.cmpnyUid)}>
              Delete
            </Button>
          )}
        </Stack>
      ),
    },
  ];

  useEffect(() => {
    if (isSuccess || isError) {
      Swal.fire({
        icon: isSuccess ? "success" : "error",
        title: `${isSuccess ? "Success" : "Error"} Delete`,
        text: `${isSuccess ? "Successfully deleted" : "Error deleting"} user account`,
        confirmButtonColor: "#051438",
      });
    }
  }, [isSuccess, isError]);
  console.log("data from table ===> ", data);
  const rows = data?.data?.map((row: any, index: number) => ({
    id: index,
    cmpnyUid: row.cpn_uid,
    cmpnyName: row.cpn_name,
    industry: row.cpn_industry,
    cmpnyEmail: row.cpn_email,
    inputted: row.cpn_regdate,
  })) || [];

  return (
    <>
      <Box sx={{ height: "650px" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnMenu
          hideFooter
          disableColumnSelector
          disableDensitySelector
          disableSelectionOnClick
        />
      </Box>
      <PaginationControl
        params={params}
        setParams={setParams}
        total={data.total_records}
      />
    </>
  );
};

export default CompanyTable;
